import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import moment from "moment";

const calcStepSize = (values) => {
  if (!values?.length) return undefined;
  const maxVal = Math.max(...values, 0);
  if (maxVal <= 10) return 1;
  if (maxVal <= 50) return 5;
  if (maxVal <= 100) return 10;
  if (maxVal <= 500) return 50;
  if (maxVal <= 1000) return 100;
  if (maxVal <= 5000) return 500;
  return undefined;
};

const TsVenueTrendDashboard = ({ loading = false, trendData = [] }) => {
  const labels = trendData.map((item) => item.date);
  const values = trendData.map((item) => item.totalCount);
  const [maxTicksLimit, setMaxTicksLimit] = useState(() => (window.innerWidth < 640 ? 4 : 12));

  useEffect(() => {
    const handleResize = () => {
      setMaxTicksLimit(window.innerWidth < 640 ? 4 : 12);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="relative flex flex-col gap-4 rounded-[24px] border border-[#e7ebf8] bg-[linear-gradient(180deg,#ffffff_0%,#fbfcff_100%)] px-6 pb-6 pt-5 shadow-[0_16px_34px_rgba(30,52,120,0.06)]">
      <div>
        <h3 className="mb-1 text-[1.1rem] font-semibold tracking-[-0.02em] text-[#1f2d4d]">Touchscreen Content Click Trend</h3>
        <p className="text-sm text-[#6b7894]">Daily touchscreen content clicks for the selected period.</p>
      </div>

      {loading ? (
        <div className="rounded-[18px] border border-[#e6ebf8] bg-[#fbfcff] px-4 py-4 text-sm text-[#7a88a6]">Loading trend data...</div>
      ) : trendData.length === 0 ? (
        <div className="rounded-[18px] border border-[#e6ebf8] bg-[#fbfcff] px-4 py-4 text-sm text-[#7a88a6]">No trend data available for the selected period.</div>
      ) : (
        <div className="w-full pt-2">
          <Line
            data={{
              labels,
              datasets: [
                {
                  label: "Content Clicks",
                  data: values,
                  borderColor: "#4a5cff",
                  backgroundColor: (ctx) => {
                    const { chart } = ctx;
                    const { chartArea } = chart;
                    if (!chartArea) return "rgba(74,92,255,0.18)";
                    const gradient = chart.ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                    gradient.addColorStop(0, "rgba(74,92,255,0.28)");
                    gradient.addColorStop(1, "rgba(74,92,255,0.02)");
                    return gradient;
                  },
                  borderWidth: 2.5,
                  pointRadius: 3,
                  pointBackgroundColor: "#4a5cff",
                  pointBorderColor: "#ffffff",
                  pointBorderWidth: 1.5,
                  pointHoverRadius: 5,
                  fill: true,
                  tension: 0.35,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: true,
              aspectRatio: 3,
              interaction: { mode: "index", intersect: false },
              plugins: {
                datalabels: { display: false },
                legend: { display: false },
                tooltip: {
                  callbacks: {
                    title: (items) => moment(items[0].label, "YYYY-MM-DD").format("MMM D, YYYY"),
                    label: (ctx) => ` ${ctx.parsed.y.toLocaleString()} clicks`,
                  },
                },
              },
              scales: {
                x: {
                  ticks: {
                    maxTicksLimit,
                    callback: function (value) {
                      return moment(this.getLabelForValue(value), "YYYY-MM-DD").format("MMM D");
                    },
                  },
                },
                y: {
                  beginAtZero: true,
                  ticks: { stepSize: calcStepSize(values) },
                  title: { display: true, text: "Clicks" },
                },
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default TsVenueTrendDashboard;
